module.exports = __webpack_public_path__ + "img/trainings-overview.8bb5f681.jpg";